import { ReactNode } from 'react';
import { Box, Modal as MuiModal } from '@mui/material';
import { useFela } from 'react-fela';
import View from '../view';
import { H1 } from '../text';
import theme from '../../../theme';

type ModalProps = {
  open: boolean;
  onClose: () => void;
  title?: string;
  children?: ReactNode;
  footer?: ReactNode;
  size?: 'default' | 'medium' | 'large';
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.colors.white,
    left: '37%',
    right: '37%',
    top: '16%',
    '@media only screen and (max-width: 1025px)': {
      left: '7%',
      right: '7%',
    },
    position: 'absolute',
    borderRadius: theme.layout.borderRadius,
    boxShadow: '0 0 15px 2px rgba(0,0,0,.1)',
    '> div': {
      padding: `${theme.layout.grid}px ${3 * theme.layout.grid}px`,
    },
  },
  container_medium: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.colors.white,
    left: '20%',
    right: '20%',
    top: '10%',
    bottom: '20%',
    position: 'absolute',
    borderRadius: theme.layout.borderRadius,
    boxShadow: '0 0 15px 2px rgba(0,0,0,.1)',
    '> div': {
      padding: `${theme.layout.grid}px ${3 * theme.layout.grid}px`,
    },
  },
  container_large: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.colors.white,
    left: '25%',
    right: '25%',
    top: '10%',
    bottom: '10%',
    position: 'absolute',
    borderRadius: theme.layout.borderRadius,
    boxShadow: '0 0 15px 2px rgba(0,0,0,.1)',
    '> div': {
      padding: `${theme.layout.grid}px ${3 * theme.layout.grid}px`,
    },
  },
  header: {
    height: '60px',
    marginTop: '12px',
    borderBottom: `1px solid ${theme.colors.lightGrey}`,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    '> h1': {
      color: theme.colors.grey,
    },
  },
  title: {},
  content: {
    flex: 1,
    marginTop: `${2 * theme.layout.grid}px`,
    marginBottom: `${3 * theme.layout.grid}px`,
    overflowY: 'auto',
  },
  footer: {
    height: 60,
    borderTop: `1px solid ${theme.colors.lightGrey}`,
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'row',
  },
};

const containerBySize = {
  default: styles.container,
  medium: styles.container_medium,
  large: styles.container_large,
};

const Modal = ({
  open,
  onClose,
  title,
  children,
  footer,
  size = 'default',
}: ModalProps) => {
  const { css } = useFela();

  return (
    <MuiModal open={open} onClose={onClose}>
      <Box tabIndex={-1} className={css({ ...containerBySize[size], outline: 'none' })}>
        {title ? (
          <View extend={styles.header}>
            <H1 text={title} />
          </View>
        ) : null}
        <View extend={styles.content}>{children}</View>
        {footer ? <View extend={styles.footer}>{footer}</View> : null}
      </Box>
    </MuiModal>
  );
};

export default Modal;
